import { ERCButton } from 'components/button'
import { useEffect, useState } from 'react'
import { SavedItem } from 'components/store/cart'
import Header from 'components/store/header'
import Layout from 'partials/layout'
import React from 'react'
import { apiRequest } from 'services'
import { baseURL } from 'services'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { showModal, closeModal } from 'store/reducers/modal'
import Shoppingcartmodal from 'components/modal/shoppingcartmodal/shoppingcartmodal'
import { toast } from 'react-toastify'
import { productSaved, productDelete } from 'store/reducers/products'

const SavedProduct = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch();
   
    const cartDetails = useSelector((state) => state?.cart?.items)
    console.log(cartDetails)
       

const token = useSelector((state) => state?.user?.data?.user?.data?.token);
//   console.log("tokenssss", token)
//  const token = JSON.parse(localStorage.getItem("token"),"{}")
//  console.log("toks",token)
//  const userToken = token?.data?.token

//  console.log(userToken)

const handleGenerateInvoice = () => {
    if (token) {
        navigate("/invoice")
    } else {
    const handleCloseModal = () => {
      dispatch(closeModal());
    };

    dispatch(showModal({
      content: <Shoppingcartmodal onClose={handleCloseModal} />
    }));
  };
}



// const savedProducts = useSelector((state) => state.product.data.saved);


// console.log(saveProduct)

  
//   const productSave = useSelector ((state) => state?.) 
// const [productDelete, setProductDelete] = useState([...productSave]);

const savingProducts = useSelector((state) => state?.product?.productSavedByUser?.saved || [])
console.log("saved Product", savingProducts)

  const totalSavedPrice = savingProducts?.reduce((acc, savingProduct) => {
    // Convert the netPrice to a number before adding
    const netPrice = parseFloat(savingProduct?.product?.price - (savingProduct?.product?.price * (savingProduct?.product?.discount / 100)));
    console.log(netPrice)
    // Ensure that netPrice is a valid number before adding it to the accumulator
    return acc + (isNaN(netPrice) ? 0 : netPrice);
}, 0);



console.log('Total Saved Price:', totalSavedPrice);

console.log(totalSavedPrice)  
const getAllsaveProductByID = async () => {
    try {
          
        const response = await fetch(`${baseURL}/product/saved`, {
            // body: JSON.stringify,
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        })
        const result = await response.json()
            // toast.success(result?.data?.message)        
        // setProductSaved(result?.data?.details)
        dispatch(productSaved(result?.data?.details))
        
        console.log('Product saved successfully:', result);
    } catch (error) {
        toast.error(error)
        // console.error('Error saving product:', error);
    } finally {
        // Any final steps
    }
};
 
// const DeleteProductBadToken = () => {
//     const handleCloseModal = () => {
//         dispatch(closeModal());
//       };
  
//       dispatch(showModal({
//         content: <Shoppingcartmodal onClose={handleCloseModal} />
//       }));
// }

const [productDelete, setProductDelete] = useState(savingProducts)
console.log(productDelete)

const deleteProductByID = async (id, index) => {
    try {
        const data = {
            productId: id
          }
        const response = await fetch(`${baseURL}/product/unsave`, {
            body: JSON.stringify(data),
            method: "DELETE",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            }

        })
        const result = await response.json()
        console.log( "hello",result)
        toast.success(result?.message)        
        // Remove the deleted product from the productSave array
        setProductDelete((prevProducts) => prevProducts.filter((_, i) => i !== index));
    } catch (error) {
        console.error('Error saving product:', error);
    } finally {
        // Any final steps
    }
};

useEffect(() => {
    getAllsaveProductByID()
    // saveProduct()
}, [])

  return (
    <Layout>
    <Header/>
    <div className='flex ml-[45px] pt-[10px] gap-[5px] cursor-pointer'onClick={() => {window.scrollTo(0,0); navigate("/shopping-cart")}}>
<img src="https://res.cloudinary.com/dmrtylvtc/image/upload/v1721893028/ERC/drowdown-arrow_suwan5.svg" />
<p> Go Back</p>
</div>

{/* 1 */}
<div className='w-full h-full flex justify-center gap-[70px] my-[3%]'>
<div className='flex flex-col gap-[40px]'>
    {
        productDelete?.length === 0 ? (
            <div className='h-full w-full text-center my-[59px]' >
                            <p className='text-2xl font-bold'>YOUR WISH LIST IS EMPTY NO ITEM HAS BEEN ADDED TO YOUT CART</p>
            </div>
        ) : (
            productDelete?.map((savingProduct, index) => (
                <div key={index}>
                     <SavedItem img={savingProduct?.product?.productImage}
    title={savingProduct?.product?.name}
    slashPrice={savingProduct?.product?.price}
    // amount={cartDetail?.product?.netPrice}
    amount={`NGN ${savingProduct?.product?.price - (savingProduct?.product?.price * (savingProduct?.product?.discount / 100))}`}
    description={savingProduct?.product?.description}
    discount={`${savingProduct?.product?.discount}%`} 
    totalPrice={`NGN ${savingProduct?.product?.price - (savingProduct?.product?.price * (savingProduct?.product?.discount / 100))}`}
    onDeleteProduct={() => deleteProductByID(savingProduct?.product?.id, index)}
    // onDeleteProduct={() => deleteProductByID(cartDetail?.product?.id)}
    // onDeleteProduct={deleteProductByID}
    />
           </div>
            ))
        )
    }
    
</div>
{/* 2 */}

{/* The Generate invoice other side */}
</div>
    </Layout>
  )
}

export default SavedProduct
